export enum PaymentFlowType {
  FIRST_PAYMENT = 'FirstPayment',
  UPSELL = 'UpsellPayment',
  MANUAL_SALE = 'ManualSale',
}
